<template>
  <div class="app-container">
    <router-view v-slot="{ Component }">
        <component :is="Component" />
    </router-view>
        <!-- 滚动到顶部按钮 -->
        <div 
      v-show="showScrollTop"
      class="fixed bottom-[3rem] right-[3rem] w-[3rem] h-[3rem] bg-main-primary rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 shadow-lg"
      @click="scrollToTop"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted, onUnmounted, ref } from 'vue'
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig'
import { CommonUtils } from "@/utils/commonUtils";
const showScrollTop = ref(false);
const handleScroll = () => {
  // 当页面滚动超过 300px 时显示按钮
  showScrollTop.value = window.scrollY > 300;
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
const sysStore = useSystemConfigStoreHook()

onBeforeMount(async () => {
  // 2. 语言国际化：把当前语言写入 <html lang="...">
  // document.documentElement.setAttribute('lang', sysStore.currentLang)
  CommonUtils.applyTheme()
  // 4. Favicon 替换：把后端下发的 logoUrl 设为 favicon
  const logoUrl = sysStore.commonConfig.logoUrl
  if (logoUrl) {
    CommonUtils.changeFavicon(logoUrl)
  }
}) 
</script>

<style scoped>
.app-container {
  width: 100%;
  min-height: 100vh;
}
</style>